import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../config/api";
import { BASE_API } from "../../../constants/apiUrls";
import { toast } from "../../../lib/toast";
import { ErrorMessage, GetSingleDataParams, PostRequest } from "../../../types";
import { AnyStatusData } from "../../../types/status/status";
import { handleApiError } from "../../../utils/errorHandler";

// update
export const updateAnyStatusAsync = createAsyncThunk<
  null,
  PostRequest<AnyStatusData, GetSingleDataParams>
>(
  "admin-status/updateAnyStatus",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateAnyStatus}`, data, {});

      reRender && reRender(true);
      toast("success", "Update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      // Handle multiple error messages
      handleApiError(error, "Update failed");
      return rejectWithValue(error);
    }
  }
);
